import { render, staticRenderFns } from "./DeviceMaintainRecord.vue?vue&type=template&id=87fee75a&scoped=true"
import script from "./DeviceMaintainRecord.vue?vue&type=script&lang=js"
export * from "./DeviceMaintainRecord.vue?vue&type=script&lang=js"
import style0 from "./DeviceMaintainRecord.vue?vue&type=style&index=0&id=87fee75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fee75a",
  null
  
)

export default component.exports